import React, { Component } from 'react';
import { Link }  from 'react-router-dom';
import SmallDestinationCard from '../SmallDestinationCard/SmallDestinationCard';
import LargeDestinationCard from '../LargeDestinationCard/LargeDestinationCard';
import LargeEventCard from '../LargeEventCard/LargeEventCard';
import FlightMap from '../FlightMap/FlightMap';

import Carousel from 'nuka-carousel';

import tripData from '../../tripData1'; // long haul

import styles from './FlightBrowse.module.css';

let destinations = [
  {
    image: require('./img/destinations/hawaii.jpg'),
    location: 'Hawaii',
    price: 399
  },
  {
    image: require('./img/destinations/mexico-city.jpg'),
    location: 'Mexico City',
    price: 350
  },
  {
    image: require('./img/destinations/new-york.jpg'),
    location: 'New York',
    price: 520
  }
]

let distantDestinations = [
  {
    image: require('./img/destinations/sydney.jpg'),
    location: 'Sydney',
    price: 1400
  },
  {
    image: require('./img/destinations/singapore.jpg'),
    location: 'Singapore',
    price: 900
  },
  {
    image: require('./img/destinations/tokyo.jpg'),
    location: 'Tokyo',
    price: 800
  },
  {
    image: require('./img/destinations/copenhagen.jpg'),
    location: 'Copenhagen',
    price: 750
  }
]

let quickTrips = [
  {
    image: require('./img/destinations/bend-oregon.jpg'),
    location: 'Bend',
    description: 'If you crave a good craft beer, Bend in central Oregon is your kind of town.',
    price: 159
  },
  {
    image: require('./img/destinations/palm-springs.jpg'),
    location: 'Palm Springs',
    description: 'This one-time playground of the stars is making a comeback as a year-round destination.',
    price: 159
  },
  {
    image: require('./img/destinations/slo.jpg'),
    location: 'San Luis Obispo',
    description: 'There is much more to San Luis Obispo than college students and a famous hotel',
    price: 99
  }
]

let events = [
  {
    image: require('./img/events/lantern-festival.jpeg'),
    location: 'PINGXI, TAIWAN',
    event: 'Lantern Festival',
    month: 'September'
  },
  {
    image: require('./img/events/carnival.jpeg'),
    location: 'VENICE, ITALY',
    event: 'Carnival',
    month: 'October'
  },
]

function renderCarouselDots(activeStateIndex) {

  const length = quickTrips.length;
  const dots = [];

  for(var i = 0; i < length; i++) {
    dots.push(
      <div
       className={styles.flightBrowseQuickTripsDecorator}
       key={i}
       style={{backgroundColor: (activeStateIndex === i) ? 'white' : 'gray'}}
       />
    )
  }

  return dots;
}
let tripTimer = undefined
class FlightBrowse extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      activeCarouselIndex: 0,
      currentTripId: 0,
    };
  }

  componentDidMount() {
    tripTimer = setInterval(() => {
      this.loadNextTrip();
    }, 6000);
  }

  componentWillUnmount() {
    clearInterval(tripTimer);
  }

  loadNextTrip() {
    const tripCount = tripData.length;
    if ((this.state.currentTripId + 1) > tripCount) {
      // no more trips, start over
      this.setState({ currentTripId: 0 });
    } else {
      this.setState({ currentTripId: this.state.currentTripId + 1 });
    }
  }

  render() {
    const component = this;

    return (
      <div style={{overflowX: 'hidden'}}>
        {/* <div>Flight Browser</div>
        <Link to="/flights" >Select destination</Link> */}

        <div className={[styles.flightBrowseHeaderWrapper, 'browseMap'].join(' ')}>
          <FlightMap
            styleID="b3nroth/cjj6yeo2x03jm2rto9w04stui"
            routeData={tripData[this.state.currentTripId]}
            lineColor="#000000"
            browse
          />
          <div className={styles.flightBrowseHeaderTitleWrapper} >
            <h1 className={styles.flightBrowseHeaderTitle}>Best flights from San Francisco</h1>
          </div>
        </div>

        {/* placeholder image until mapbox is inserted */}

        <h3 className={styles.flightBrowsePopularDestinationsHeader}>Popular destinations</h3>

        <div className={styles.flightBrowsePopularDestinationsWrapper} style={{overflowX: 'scroll'}}>
          <div className={styles.flightBrowseDestinationContainer}>
            {destinations.map(function(destination, index){
              return(
                <Link to='/flights' key={index}><SmallDestinationCard image={destination.image} location={destination.location} price={destination.price}/></Link>
              )
            })}
          </div>
        </div>

        <div className={styles.flightBrowseFireWorksContainer}>
            <h1>Greatest 4th of July fireworks displays</h1>
            <h3>Flights starting at $299</h3>

            <div className={styles.flightBrowseFireWorksButton}>
              <p>See top 10 destinations</p>
            </div>
        </div>

        <div className={styles.flightBrowseDistantDestinationsWrapper}>
          <h3 className={styles.flightBrowseDistantDestinationsHeader}>Distant Destinations</h3>
          {distantDestinations.map( (destination, index) => (
            <Link to='/flights' key={index}><LargeDestinationCard location={destination.location} image={destination.image} price={destination.price}/></Link>
            ))
          }
        </div>

        <div className={styles.flightBrowseQuickTripsWrapper}>
          <Carousel
            afterSlide={(slideIndex) => { component.setState({ activeCarouselIndex: slideIndex }) }}
            renderBottomCenterControls={() => (<span></span>)}
            style={{height: 600}}>
            
            {quickTrips.map((trip, index) => (
                <div className={styles.flightBrowseQuickTripsContainer} key={index}>
                  <img className={styles.flightBrowseQuickTripsImage} src={trip.image} alt="" />
                  {/* <div className={styles.flightBrowseQuickTripsGradient}></div> */}

                  <p className={styles.flightBrowseQuickTripsHeader} >QUICK TRIPS FROM SAN FRANCISCO</p>

                  <div className={styles.flightBrowseQuickTripsInfoContainer}>
                    <h1>{trip.location}</h1>

                    <h3>{trip.description}</h3>

                    <p>Starting from <span>${trip.price}</span></p>
                  </div>
                </div>
              ))
            }
          </Carousel>

          <div className={styles.flightBrowseQuickTripsDecorators}>
            {renderCarouselDots(this.state.activeCarouselIndex)}
          </div>

        </div>


        <div className={styles.flightBrowseEventsWrapper}>
            <h3 className={styles.flightBrowseEventsHeader}>Unique Events Around the World</h3>
            <div className={styles.flightBrowseEventsContainer}>
              {events.map(function(event, index){
                return(
                  <LargeEventCard key={index} location={event.location} event={event.event} image={event.image} month={event.month}/>
                )
              })}
            </div>
        </div>

        <div className={styles.flightBrowseMoreButton}>
          <p>See more</p>
        </div>


      </div>
    );
  }
}

export default FlightBrowse;



// WEBPACK FOOTER //
// ./src/components/FlightBrowse/FlightBrowse.jsx